import { BKJIcon } from '@bookjane2/bookjane-design-library';

import { CreateShiftCardContext } from 'pages/CreateShiftsPage/BulkCreateShiftView/CreateShiftCard/CreateShiftCard.context';
import { prettyShiftTime } from 'pages/CreateShiftsPage/BulkCreateShiftView/CreateShiftModal/src/components/ShiftTimeAndPosition/ShiftTimeAndPosition.utils';
import {
  ShiftTimeWrapper,
  PositionNameCaption,
  ShiftTimeCaption,
} from 'pages/CreateShiftsPage/BulkCreateShiftView/CreateShiftModal/src/components/ShiftTimeAndPosition/ShiftTimeAndPosition.styled';
import {
  PositionNameLabelProvider,
  usePositionNameLabelContext,
} from 'pages/CreateShiftsPage/components/PositionNameLabel/PositionNameLabel.context';

import { useContext } from 'react';
import { useSelector } from 'react-redux';
import { castStringToInteger } from 'utils';
import { useTranslation } from 'react-i18next';
import isUserTimeFormat24hSelector from 'store/selectors/userSelectors/isUserTimeFormat24hSelector';

const PositionLabel = () => {
  const { positionName } = usePositionNameLabelContext();
  return <PositionNameCaption>{positionName || ' '}</PositionNameCaption>;
};

export function ShiftTimeAndPosition() {
  const { createShift } = useContext(CreateShiftCardContext);
  const { position_id, startDate, startAt, endAt } = createShift.values;
  const { i18n } = useTranslation();
  const is24hTimeFormat = useSelector(isUserTimeFormat24hSelector);
  return (
    <>
      <ShiftTimeWrapper alignItems="center">
        <BKJIcon iconName="ShiftsTime" />
        <ShiftTimeCaption>
          {prettyShiftTime(startDate, startAt[0], endAt[0], i18n.language, is24hTimeFormat)}
        </ShiftTimeCaption>
      </ShiftTimeWrapper>
      <PositionNameLabelProvider position_id={castStringToInteger(position_id[0])}>
        <PositionLabel />
      </PositionNameLabelProvider>
    </>
  );
}
